import { Link } from 'react-router-dom'
import XPBar from './XPBar'
import './Header.css'

export default function Header({ user, onLogout }) {
  return (
    <header className="header">
      <div className="container header-content">
        <Link to="/" className="header-brand">
          <span className="brand-icon">🎮</span>
          <span className="brand-name">Ocean Daniel</span>
        </Link>

        <nav className="header-nav">
          <Link to="/favorites" className="nav-link">
            <span className="nav-icon">⭐</span>
            <span className="nav-text">Favorites</span>
          </Link>
        </nav>

        <div className="header-user">
          <Link to="/profile" className="user-profile">
            <img
              src={user.avatar_url || '/avatars/link.svg'}
              alt={user.display_name}
              className="user-avatar"
            />
            <div className="user-info">
              <div className="user-name">{user.display_name}</div>
              <div className="user-level">Level {user.current_level || 1}</div>
            </div>
          </Link>

          <XPBar
            currentXP={user.total_xp || 0}
            xpForNextLevel={user.xp_to_next_level || 100}
          />

          <button onClick={onLogout} className="btn btn-secondary btn-logout">
            Logout
          </button>
        </div>
      </div>
    </header>
  )
}
